import { Breadcrumb, Card, EventHandler, SofturaTable } from "client/CommonComponents";
import "./AssetAuditResetHistoryLog.scss";

const AssetAuditResetHistoryLog = (props: any) => {
  const {
    breadcrumlist,
    handleClickBack,
    columns,
    gridData,
    serverTotal,
    fetchAction,
    pagesCount,
    isGridLoading,
    showGrid,
  } = props;

  return (
    <>
      {showGrid && (
        <div className="breadCrumbBlock">
                    <EventHandler onEvent={handleClickBack} data-attribute="AssetAuditResetHistoryLog_Default_EventHandler">
                      <div className="backButton mb-sm-2 mb-3">
                        <span className="fa fa-chevron-left"></span>
                        Back
                      </div>
                    </EventHandler>         
          <div className="breadcrumbList">
            <Breadcrumb items={breadcrumlist} maxDisplayedItems="5"  data-attribute="AssetAuditResetHistoryLog_Default_Breadcrumb" />
          </div>
        </div>
      )}

      {showGrid && (
        <Card data-attribute="AssetAuditResetHistoryLog_Default_Card">
          <div className="create-new-order-container">
            <div className="grid-block pt-2">
              <div className="mb-1 top-section">
                <p className="mt-1">ASSET AUDIT HISTORY LOG</p>
              </div>
              {showGrid && (
                <div
                  className={`order-listing-grid pe-0 ${
                    gridData?.length !== 0
                      ? "softura-table filterTable"
                      : "softura-table filterTable paginationNav"
                  }`}
                >
                  <SofturaTable
                    data={gridData ?? []}
                    columns={columns}
                    sort={true}
                    defaultPageSize={10}
                    pageSizes={[10, 20, 50]}
                    globalSearch={false}
                    filter={false}
                    defaultPaginationPosition="Both"
                    fixedHeader={true}
                    serverTotal={serverTotal}
                    fetchAction={fetchAction}
                    isServerSide={true}
                    pagesCount={pagesCount}
                    loading={isGridLoading}
                   data-attribute="AssetAuditResetHistoryLog_Default_Grid" />
                </div>
              )}
            </div>
          </div>
        </Card>
      )}
    </>
  );
};

export default AssetAuditResetHistoryLog;
